import {Box, Button} from "@mui/material";
import React, { useContext } from 'react'
import { NextWindowContext } from '../../../context/NextWindowContext'

interface SlidesComponentProps {
    data: any;
    isFinished?: boolean;
    lastLesson?: boolean;
}

export const SlidesComponent = ({data, isFinished, lastLesson}: SlidesComponentProps) => {
  const nextWindow = useContext(NextWindowContext)
    return (
        <Box sx={{
            position: 'relative',
            height: '478px',
            width: '100%',
            background: '#808992',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <Button
                variant="contained"
                color="primary"
                href={data.slides}
                sx={{
                    background: '#fff',
                    color: '#000',
                    '&:hover': {
                        background: '#d5d5d5',
                        color: '#000',
                    },
                }}

            >
                Скачать презинтацию</Button>
          <Button
            sx={{
              position: 'absolute',
              bottom: '-80px',
              right: '20px',
            }}
            variant='contained'
            onClick={() => {
              nextWindow()
            }}
          >
              {isFinished && lastLesson ? 'Завершить прохождение курса' : 'Далее'}
          </Button>
        </Box>
    )
}